<template>
    <div id="app">
        <router-view/>
        <template v-if="isPC">
            <nv-footer v-if="platformConfig.platformConfigValue == 1"></nv-footer>
            <nv-footer-global v-if="platformConfig.platformConfigValue == 2"></nv-footer-global>
        </template>

    </div>
</template>

<script>
    import nvFooter from './components/footer.vue'
    import nvFooterGlobal from './components/footer_global'

    export default {
        name: 'App',
        data () {
            return {
                isPC: false,
                platformConfig: Platform_Config,
            }
        },
        components: {
            nvFooter,
            nvFooterGlobal
        },
        created() {
            var width = document.documentElement.clientWidth;
            if (width <= 767) {
                // 手机端逻辑
                this.isPC = false;
            } else {
                // PC端逻辑
                this.isPC = true;
            }
        },
    }
</script>

<style>
    @import "assets/style/normalize.css";
    @import "assets/style/main.css";

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*text-align: center;*/
        color: #2c3e50;
    }

    .el-message {
        z-index: 99999 !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue